// extracted by mini-css-extract-plugin
export default {"dragHandle":"DragHandle_dragHandle__ZAudt","disabled":"DragHandle_disabled__dHeNJ"};